export const getAvigilonAccessOrganizationUrl = (
  organizationId: string | null,
): string | undefined =>
  organizationId
    ? `https://access.alta.avigilon.com/o/${encodeURIComponent(organizationId)}`
    : undefined;

export const getAvigilonAccessSiteUrl = (
  organizationId: string | null,
  siteId: string | undefined,
): string | undefined => {
  const organizationUrl = getAvigilonAccessOrganizationUrl(organizationId);
  return organizationUrl && siteId
    ? `${organizationUrl}/sites/edit?siteId=${encodeURIComponent(siteId)}`
    : undefined;
};
